import Header from "@/components/Header";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";

/**
 * Context type shared across all routes via TanStack Router.
 * Contains authentication state accessible throughout the application.
 */
export interface RouterContext {
  auth: {
    /** Whether the current user is authenticated */
    isAuthenticated: boolean;
    /** Unique identifier of the authenticated user, or null/undefined if not authenticated */
    userId: string | null | undefined;
  };
}

/**
 * Root route configuration for the application.
 * Serves as the entry point for all routes and provides shared context.
 */
export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
});

/**
 * Root layout component that wraps all application routes.
 * Provides consistent header and devtools across all pages.
 *
 * @returns The root layout with header, route outlet, and devtools
 */
function RootLayout() {
  return (
    <div className="min-h-screen bg-[#fafafa] text-gray-900 antialiased">
      <Header />
      <Outlet />
    </div>
  );
}
